import React from 'react';
import "../css/payment.css";

function PDFAddress({ dataTabelB }) {
  const d = dataTabelB || {};

  // ชื่อ: ใช้ customerFullname (ข้อมูลบอกเลิกที่บันทึกแล้ว) ก่อน
  //       สำรองด้วย SNAM + NAME1 + NAME2 (ข้อมูลสดจาก DB2)
  const fullName =
    d.customerFullname ||
    [d.SNAM, d.NAME1, d.NAME2]
      .filter((p) => p !== null && p !== undefined && String(p).trim() !== "")
      .map((p) => String(p).trim())
      .join(" ");

  // เลขสัญญา: contractNo (บันทึกแล้ว) หรือ CONTNO (DB2)
  const contno = d.contractNo ?? d.CONTNO ?? "";

  // ประเภท: customerTypeId (บันทึกแล้ว) หรือ GARNO (DB2) — 0 = ผู้ทำสัญญา, 1,2,... = ผู้ค้ำประกัน
  const rawType = d.customerTypeId !== null && d.customerTypeId !== undefined
    ? d.customerTypeId
    : d.GARNO;
  const typeId = Number(rawType);
  const roleLabel =
    typeId === 0
      ? "ผู้ทำสัญญา"
      : `ผู้ค้ำประกัน${Number.isNaN(typeId) ? "" : typeId}`;

  // ที่อยู่: รองรับทั้งแบบ flat (ADDR1/TUMB/...) และ nested (address.ADDR/...)
  const addr = d.address || {};
  const ADDR1 = d.ADDR1 ?? addr.ADDR ?? addr.ADDR1 ?? "";
  const ADDR2 = d.ADDR2 ?? addr.ADDR2 ?? "";
  const TUMB = d.TUMB ?? addr.TUMB ?? "";
  const AUMPDES = d.AUMPDES ?? addr.AUMPDES ?? "";
  const PROVDES = d.PROVDES ?? addr.PROVDES ?? "";
  const PROVCOD = d.PROVCOD ?? addr.PROVCOD ?? "";
  const ZIP = d.ZIP ?? addr.ZIP ?? "";

  let T1, A1, J1;
  J1 = `จ. ${PROVDES}`;
  if (PROVCOD === "01") {
    T1 = `แขวง ${TUMB}`;
    A1 = `เขต ${AUMPDES}`;
  } else {
    T1 = `ต.${TUMB}`;
    A1 = `อ.${AUMPDES}`;
  }

  return (
    <div style={{ fontSize: '16px', color: '#000' }}>
      {fullName} ({roleLabel}) ({contno}) <br/>
      เลขที่ {ADDR1} {ADDR2} <br/>
      {T1} {A1} {J1} <br/>
      {ZIP} <br/>
      <div style={{ borderBottom: '1px solid #000', width: '100%' }}></div>
    </div>
  );
}

export default PDFAddress;
